module.exports = __webpack_public_path__ + "assets/c9ac807c6831413ca0aae95ada4f93aa.mp4";